import { render, staticRenderFns } from "./SelectTermComponent.vue?vue&type=template&id=360637c6&scoped=true&"
import script from "./SelectTermComponent.vue?vue&type=script&lang=ts&"
export * from "./SelectTermComponent.vue?vue&type=script&lang=ts&"
import style0 from "./SelectTermComponent.vue?vue&type=style&index=0&id=360637c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360637c6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
